import React from 'react'

import ProjectCarouselButtons from '../ProjectCarouselButtons'

const RealtimeTFOD = () => {
    return (
        <>
            <div className="Project--split--window">
                <div className="Project-Carousel-info-container">
                    <div id="carouselExampleIndicatorsRealtimeTFOD" className="carousel slide Project-Carousel-container">

                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <video controls="controls" className="d-block w-100">
                                    <source src="../IMG/Realtime-TFOD/GestureDetectionDemo.mp4" type="video/mp4" />
                                </video>
                            </div>
                        </div>

                        <ProjectCarouselButtons tag="RealtimeTFOD" />

                    </div>

                    <div className="Project-info-container">
                        <div className="Project--info--Para-container">
                            <p className="Project--info--heading">Realtime--TFOD</p>
                            <p className="Project--info--subheading">Gesture Detection</p>
                            <p className="Project--info--subheading">Deep Learning</p>
                            <p className="Project--info--Para">Realtime-TFOD is a system that performs real-time gesture detection and classification using computer vision and deep learning. This project focuses on recognizing specific hand gestures such as hello, thumbs-up, thumbs-down, and namaste, providing a robust platform for intuitive interaction between humans and machines.</p>
                            <p className="Project--info--Para">Real-time gesture recognition using deep learning, customizable labels, and versatile applications in HCI, robotics, and assistive technology.</p>
                        </div>
                        <div className="Project--info--links">
                            <a href="https://github.com/Chauhan-Aman/Realtime--TFOD" target='__blank'>Github</a>
                        </div>
                        <div className="Project--info--tech">
                            <p>Computer Vision</p>
                            <p>Deep Learning</p>
                            <p>Python</p>
                            <p>TensorFlow</p>
                            <p>OpenCV</p>
                            <p>pyqt5</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RealtimeTFOD